module.exports = __webpack_public_path__ + "static_pc/img/8.540dd237.png";